import { axiosPost } from '@/api/handlers';
import { useMutation } from '@/api/hooks';

export const useUploadContractorPayment = () => {
  return useMutation({
    mutationFn: async ({
      projectId,
      csvData,
    }: {
      projectId: string;
      csvData: (string | number)[][];
    }) => {
      return await axiosPost(
        `/api/projects/${projectId}/contractor-payments/csv-upload/`,
        { csv: csvData },
      );
    },
  });
};
